import { useEffect, useRef } from "react";
import ResizeObserver from "resize-observer-polyfill";
import throttle from "lodash/throttle";
import { defer, noop } from "lib/utils";

const RESIZE_THROTTLE_MS = 200;

const useResizeObserver = ({ id, element = document.body, onResize = noop }) => {
  const resizeObserverRef = useRef();

  useEffect(() => {
    resizeObserverRef.current = {
      handleBodyResize: () => {
        const { width, height } = element?.getBoundingClientRect?.();

        if (width > 0 && height > 0) {
          onResize({ width, height });

          window.parent.postMessage(
            {
              action: `${id}-otrl-jp-widget__resize`,
              width,
              height
            },
            "*"
          );
        }
      }
    };

    resizeObserverRef.current.observer = new ResizeObserver(entries => {
      // We wrap it in requestAnimationFrame to avoid this error - ResizeObserver loop limit exceeded
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        return throttle(resizeObserverRef.current.handleBodyResize, RESIZE_THROTTLE_MS)(entries);
      });
    });

    resizeObserverRef.current.observer.observe(document.body);

    defer(resizeObserverRef.current.handleBodyResize, RESIZE_THROTTLE_MS);

    return () => {
      resizeObserverRef.current.observer.unobserve(document.body);
    };
  }, [element, id, onResize]);
};

export default useResizeObserver;
